// extracted by mini-css-extract-plugin
export var actionButton = "_g0-t";
export var buttonContainer = "_g0-0";
export var buttonContainer2 = "_g0-1";
export var buttonSection = "_g0-2";
export var details = "_g0-3";
export var dropdownItem = "_g0-5";
export var dropdownItemsContainer = "_g0-4";
export var fileInput = "_g0-r";
export var headerButton = "_g0-6";
export var icon = "_g0-7";
export var input = "_g0-8";
export var macroListItem = "_g0-9";
export var mainContent = "_g0-a";
export var microText = "_g0-b";
export var modal = "_g0-w";
export var optionsButton = "_g0-c";
export var paperclip = "_g0-s";
export var pillContent = "_g0-d";
export var preview = "_g0-e";
export var preview2 = "_g0-f";
export var quillEditor = "_g0-q";
export var selectedMacro = "_g0-g";
export var sidebar = "_g0-h";
export var sidebarHeader = "_g0-j";
export var sidebarList = "_g0-i";
export var sidebarListItem = "_g0-k";
export var sidebarSearch = "_g0-l";
export var snoozeDurationWrapper = "_g0-v";
export var statusPillContainer = "_g0-m";
export var tagsContainer = "_g0-n";
export var unselectedMacro = "_g0-o";
export var variable = "_g0-u";
export var wrapper = "_g0-p";